import { InputProps, Select as FormSelect } from '@rebass/forms';
import { FormComboGroup, Input } from '../Form';
import React, { ChangeEvent, useCallback } from 'react';
import { FlexProps } from 'rebass';
import { normalizePhone } from '@ecosconnect/core/src/helpers/string';
import { PhoneInput } from './types';

const phoneTypes = [
  { value: 'UNKNOWN', label: '-' },
  { value: 'HOME', label: 'Home' },
  { value: 'CELL', label: 'Cell' },
  { value: 'WORK', label: 'Work' },
  { value: 'FAX', label: 'Fax' },
  { value: 'OTHER', label: 'Other' },
];

type PhoneInputGroupProps = Omit<FlexProps, 'value' | 'onChange'> & {
  index: number;
  value: PhoneInput;
  inputProps?: InputProps;
  onChange?: (
    type: 'phone' | 'email',
    value: PhoneInput,
    index: number
  ) => void;
};

const PhoneInputGroup: React.FC<PhoneInputGroupProps> = (props) => {
  const { value, index, onChange } = props;

  const onTypeChange = useCallback(
    (e: ChangeEvent<any>) => {
      if (onChange) {
        onChange(
          'phone',
          {
            ...value,
            subType: e.target.value,
          },
          index
        );
      }
    },
    [value, onChange]
  );

  const onValueChange = useCallback(
    (e: ChangeEvent<any>) => {
      if (onChange) {
        onChange(
          'phone',
          {
            ...value,
            value: normalizePhone(e.target.value),
          },
          index
        );
      }
    },
    [value, onChange]
  );

  return (
    <FormComboGroup
      {...{ ...(props as any), value: undefined, onChange: undefined }}
    >
      <FormSelect
        variant="selectCombo"
        value={value.subType ?? 'UNKNOWN'}
        onChange={onTypeChange}
        sx={{ width: 100, flexShrink: 0 }}
      >
        {phoneTypes.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </FormSelect>
      <Input
        type="text"
        variant="inputRoundedRight"
        value={value.value}
        onChange={onValueChange}
        data-index={index}
        name="phones"
        placeholder="Phone"
        autoComplete="off"
        {...(props.inputProps as any)}
      />
    </FormComboGroup>
  );
};

export default PhoneInputGroup;
